<template>
  <div class="mysql-instanceUser-page">
    <Drawer
      :title="addPrivsModalTitle"
      v-model="addPrivsModal"
      width="1024"
      :mask-closable="true"
      @on-close="addPrivsCancel">
      <div>
        <i-form ref="addPrivsForm" :model="addPrivsForm" :label-width="80">
          <form-item label="数据库列表" prop="dblist">
            <transfer
              :data="databaseList"
              :target-keys="addPrivsForm.dblist"
              :list-style="listStyle"
              @on-change="addPrivsDBChange"
              filterable></transfer>
          </form-item>
          <form-item label="权限列表" prop="syspriv">
            <transfer
              :data="sysPrivList"
              :target-keys="addPrivsForm.syspriv"
              :list-style="listStyle"
              @on-change="addPrivsPrivChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="addPrivsSubmit">提交</i-button>
            <i-button style="margin-left: 8px" @click="addPrivsCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>

    <Drawer
      :title="addUserModalTitle"
      v-model="addUserModal"
      width="1024"
      :mask-closable="true"
      @on-close="addUserCancel">
      <div>
        <i-form ref="addUserForm" :model="addUserForm" :label-width="80"
                :rules="addUserRuleValidate">
          <form-item label="账户名" prop="name">
            <i-input v-model="addUserForm.name" placeholder=""></i-input>
          </form-item>
          <form-item label="网段" prop="network_segment">
            <i-input v-model="addUserForm.network_segment" placeholder="置空默认为 %"></i-input>
          </form-item>
          <form-item label="账号类型" prop="type">
            <RadioGroup v-model="addUserForm.type">
              <Radio label='1'>管理维护账号</Radio>
              <Radio label='2'>普通账号</Radio>
            </RadioGroup>
          </form-item>
          <form-item label="密码" prop="password">
            <i-input type="password" v-model="addUserForm.password" placeholder="大写、小写、数字、特殊字符至少各一位，长度8位以上"></i-input>
          </form-item>
          <form-item label="确认密码" prop="repassword">
            <i-input type="password" v-model="addUserForm.repassword" placeholder=""></i-input>
          </form-item>
          <form-item v-if="addUserForm.type === '2'" label="数据库列表" prop="dblist">
            <transfer
              :data="databaseList"
              :target-keys="addUserForm.dblist"
              :list-style="listStyle"
              @on-change="addUserDBChange"
              filterable></transfer>
          </form-item>
          <form-item label="权限列表" prop="syspriv">
            <transfer
              :data="sysPrivList"
              :target-keys="addUserForm.syspriv"
              :list-style="listStyle"
              @on-change="addUserPrivChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="addUserSubmit">提交</i-button>
            <i-button style="margin-left: 8px" @click="addUserCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>

    <Drawer
      :title="resetPasswordModalTitle"
      v-model="resetPasswordModal"
      width="500"
      :mask-closable="true"
      @on-close="resetPasswordCancel">
      <div>
        <i-form ref="resetPasswordForm" :model="resetPasswordForm" :label-width="90"
                :rules="resetPasswordRuleValidate">
          <form-item label="新密码" prop="password">
            <i-input type="password" v-model="resetPasswordForm.password"  placeholder="大写、小写、数字、特殊字符至少各一位，长度8位以上"></i-input>
          </form-item>
          <form-item label="确认密码" prop="repassword">
            <i-input type="password" v-model="resetPasswordForm.repassword" placeholder=""></i-input>
          </form-item>
          <form-item>
            <i-button type="primary" @click="resetPassword">提交</i-button>
            <i-button style="margin-left: 8px" @click="resetPasswordCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>

    <Drawer
      :title="revokePrivModalTitle"
      v-model="revokePrivModal"
      width="972"
      :mask-closable="true"
      @on-close="revokePrivCancel">
      <div>
        <i-form ref="revokePrivForm" :model="revokePrivForm" :label-width="80">
          <form-item label="权限" prop="privileges">
            <transfer
              :data="privList"
              :target-keys="revokePrivForm.privileges"
              :list-style="listStyle"
              @on-change="privChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="revokePrivilege">提交</i-button>
            <i-button style="margin-left: 8px" @click="revokePrivCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>
    <Card shadow>
      <Row>
        <i-col span="24">
          <h1>{{this.$route.query.name}}</h1>
          <Divider />
        </i-col>
      </Row>
      <Row>
        <i-col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="用户名" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getInstanceUser()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getInstanceUser()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="6" class="align-right">
        <Button @click="addUser()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加用户</Button>
        <Button @click="refresh()" type="primary" :style="{marginBottom: '10px', marginLeft: '10px'}" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
      <tables ref="instanceUserTable" height="600" search-place="top" v-model="instanceUserData" :columns="userColumns"  class="mob-remove-table-fixed"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstanceUser"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getInstanceUserList, resetUserPassword, deleteInstanceUser, getPrivList, revokePrivilege,
  showDatabaseList, createUser, addPrivs, lockInstanceUser, unlockInstanceUser} from '@/api/mysql'

export default {
  name: 'MySQLInstanceUser',
  components: {
    Tables
  },
  data: function () {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    const validateUserPassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.addUserForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    return {
      searchForm: {
        name: ''
      },
      roleStyle: {
        display: 'none'
      },
      listStyle: {
        width: '400px',
        height: '300px'
      },
      // 回收权限
      revokePrivModal: false,
      revokePrivModalTitle: '权限回收',
      revokePrivForm: {
        roles: [],
        privileges: []
      },
      roleList: [],
      privList: [],

      // 重置密码
      resetPasswordModal: false,
      resetUser: null,
      resetPasswordModalTitle: '重置密码',
      resetPasswordForm: {
        password: '',
        repassword: ''
      },
      resetPasswordRuleValidate: {
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        repassword: [{validator: validatePassCheck, trigger: 'blur'}]
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      userColumns: [
        {title: '用户', key: 'user', align: 'center', width: 200, fixed: 'left'},
        {title: '锁定状态', key: 'account_locked', align: 'center', width: 200},
        {title: '权限', key: 'privs', type: 'html', minWidth: 400},
        {
          title: '操作',
          fixed: 'right',
          width: 130,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    margin: '5px'
                  },
                  on: {
                    click: () => {
                      this.resetUser = params.row.user
                      this.getDatabases()
                      this.addPrivsModal = true
                    }
                  }
                }, [
                  h('div', '添加权限')
                ]),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                    // shape: 'circle'
                  },
                  style: {
                    margin: '5px'
                  },
                  on: {
                    click: () => {
                      this.resetUser = params.row.user
                      this.resetPasswordModal = true
                    }
                  }
                }, [
                  h('div', '重置密码')
                ]),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                    // shape: 'circle'
                  },
                  style: {
                    margin: '5px'
                  },
                  on: {
                    click: () => {
                      let data = {
                        id: this.$route.query.id,
                        user: params.row.user
                      }
                      this.resetUser = params.row.user
                      this.getPrivs(data)
                      this.revokePrivModal = true
                    }
                  }
                }, [
                  h('div', '权限回收')
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '您确定要锁定账号吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleLock(params.row.user)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      margin: '5px'
                    }
                  }, [
                    h('div', '锁定')
                  ])
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '您确定要解锁账号吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleUnlock(params.row.user)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      margin: '5px'
                    }
                  }, [
                    h('div', '解锁')
                  ])
                ]),
                h('Poptip', {
                  props: {
                    transfer: true,
                    confirm: true,
                    placement: 'bottom',
                    title: '您确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params.row.user)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      margin: '5px'
                    }
                  }, [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ],
      instanceUserData: [],

      // 添加用户
      addUserModalTitle: '创建账号',
      addUserModal: false,
      databaseList: [],
      addUserForm: {
        id: this.$route.query.id,
        name: '',
        network_segment: '',
        password: '',
        type: '2',
        dblist: [],
        syspriv: []
      },
      addUserRuleValidate: {
        name: [{required: true, message: '请输入数据库账户', trigger: 'blur'}],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        repassword: [{validator: validateUserPassCheck, trigger: 'blur'}]
      },
      sysPrivList: [
        {label: 'ALL PRIVILEGES(选了该项，不能选择其他项)', key: 'ALL PRIVILEGES'},
        {label: 'ALTER', key: 'ALTER'},
        {label: 'ALTER ROUTINE', key: 'ALTER ROUTINE'},
        {label: 'CREATE', key: 'CREATE'},
        {label: 'CREATE ROUTINE', key: 'CREATE ROUTINE'},
        {label: 'CREATE TEMPORARY TABLES', key: 'CREATE TEMPORARY TABLES'},
        {label: 'CREATE VIEW', key: 'CREATE VIEW'},
        {label: 'DELETE', key: 'DELETE'},
        {label: 'DROP', key: 'DROP'},
        {label: 'EVENT', key: 'EVENT'},
        {label: 'EXECUTE', key: 'EXECUTE'},
        {label: 'INDEX', key: 'INDEX'},
        {label: 'INSERT', key: 'INSERT'},
        {label: 'LOCK TABLES', key: 'LOCK TABLES'},
        {label: 'SELECT', key: 'SELECT'},
        {label: 'SHOW VIEW', key: 'SHOW VIEW'},
        {label: 'TRIGGER', key: 'TRIGGER'},
        {label: 'UPDATE', key: 'UPDATE'},
        {label: 'USAGE', key: 'USAGE'}
      ],

      // 添加授权
      addPrivsModalTitle: '添加授权',
      addPrivsModal: false,
      addPrivsForm: {
        id: this.$route.query.id,
        name: '',
        dblist: [],
        syspriv: []
      }
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getInstanceUser()
    },
    refresh () {
      this.getInstanceUser()
    },
    getInstanceUser (value = 1) {
      this.page = value
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        ordering: this.ordering,
        name: this.searchForm.name
      }
      getInstanceUserList(params).then(res => {
        this.instanceUserData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取用户列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取用户列表失败！服务器无响应'
          })
        }
      })
    },

    resetPasswordCancel () {
      this.resetPasswordForm.password = ''
      this.resetPasswordForm.repassword = ''
      this.resetPasswordModal = false
    },

    resetPassword () {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.$route.query.id,
            user: this.resetUser,
            password: this.resetPasswordForm.password
          }
          resetUserPassword(data).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getInstanceUser()
            this.resetPasswordCancel()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    handleDelete (user) {
      let data = {
        id: this.$route.query.id,
        user: user
      }
      deleteInstanceUser(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstanceUser()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    handleLock (user) {
      let data = {
        id: this.$route.query.id,
        user: user
      }
      lockInstanceUser(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstanceUser()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    handleUnlock (user) {
      let data = {
        id: this.$route.query.id,
        user: user
      }
      unlockInstanceUser(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstanceUser()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    getPrivs (data) {
      let that = this
      that.privList = []
      getPrivList(data).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.privList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },
    privChange (newTargetKeys) {
      this.revokePrivForm.privileges = newTargetKeys
    },
    revokePrivCancel () {
      this.revokePrivForm.privileges = []
      this.revokePrivForm.roles = []
      this.revokePrivModal = false
    },
    revokePrivilege () {
      this.$refs['revokePrivForm'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.$route.query.id,
            user: this.resetUser,
            privileges: this.revokePrivForm.privileges
          }
          revokePrivilege(data).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.getInstanceUser()
            this.revokePrivCancel()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    },
    addUser () {
      this.getDatabases()
      this.addUserModal = true
    },

    addUserDBChange (newTargetKeys) {
      this.addUserForm.dblist = newTargetKeys
    },
    addUserPrivChange (newTargetKeys) {
      this.addUserForm.syspriv = newTargetKeys
    },
    addPrivsDBChange (newTargetKeys) {
      this.addPrivsForm.dblist = newTargetKeys
    },
    addPrivsPrivChange (newTargetKeys) {
      this.addPrivsForm.syspriv = newTargetKeys
    },

    getDatabases () {
      let params = {
        id: this.$route.query.id
      }
      let that = this
      that.databaseList = []
      showDatabaseList(params).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.databaseList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    addUserCancel () {
      this.addUserForm.name = ''
      this.addUserForm.network_segment = ''
      this.addUserForm.password = ''
      this.addUserForm.repassword = ''
      this.addUserForm.type = '2'
      this.addUserForm.dblist = []
      this.addUserForm.syspriv = []
      this.addUserModal = false
    },
    addUserSubmit () {
      this.$refs['addUserForm'].validate((valid) => {
        if (valid) {
          createUser(this.addUserForm).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.getInstanceUser()
            this.addUserCancel()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    },

    addPrivsCancel () {
      this.addPrivsForm.dblist = []
      this.addPrivsForm.syspriv = []
      this.addPrivsModal = false
    },

    addPrivsSubmit () {
      this.$refs['addPrivsForm'].validate((valid) => {
        if (valid) {
          this.addPrivsForm.name = this.resetUser
          addPrivs(this.addPrivsForm).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.getInstanceUser()
            this.addPrivsCancel()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    }
  },

  mounted: function () {
    this.getInstanceUser()
  }
}
</script>
<style lang="less">
  @media screen and (max-width:640px) {
    .mysql-instanceUser-page {
      h1 {
        font-size: 1.5em;
      }
      .ivu-divider-horizontal{
        margin:10px 0 15px;
      }
    }
  }
</style>
